import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translationEN from "../translations/en/translations.json";
import translationES from "../translations/es/translations.json";

const resources = {
    en: {
        translation: translationEN,
    },
    es: {
        translation: translationES,
    },

};

export const init_i18n = () => {
    i18n

        .use(LanguageDetector)
        .use(initReactI18next)

        .init({
            resources,
            fallbackLng: "en",
        });
};
